import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuthBroadcast = () => {
        const navigate = useNavigate();

        useEffect(() => {
                const channel = new BroadcastChannel('auth');

                // Handle logout messages from other tabs
                channel.onmessage = (event) => {
                        if (event.data === 'logout') {
                                sessionStorage.clear();
                                navigate('/login');
                        }
                };

                // Force logout if token doesn't exist (e.g., reopened tab)
                const token = sessionStorage.getItem('token');
                if (!token) {
                        navigate('/login');
                }

                // On tab close or reload, broadcast logout
                const handleUnload = () => {
                        sessionStorage.clear();
                        channel.postMessage('logout');
                };

                window.addEventListener('beforeunload', handleUnload);

                return () => {
                        channel.close();
                        window.removeEventListener('beforeunload', handleUnload);
                };
        }, []);
};

export default useAuthBroadcast;
